import { useWebsiteSettings } from 'client/store'
import { useEffect, useState } from 'react'
import { websitePagesQuery } from 'src/editor/api/queries/website-pages-query'
import { DOMAIN_PLACEHOLDER } from 'src/editor/shared/constants/website-consts'
import {
  getCurrentWebsiteLocale,
  getWebsiteDomain,
  getWebsiteId,
  getWebsiteLocale,
} from 'src/editor/store/website-settings/website-settings-selector'
import { removeLocalePrefixFromPath } from '../utils/remove-locale-prefix-from-path'

interface UseWebsiteDomainProps {
  websitePageId: number
}

export const useWebsiteUrl = ({ websitePageId }: UseWebsiteDomainProps) => {
  const websiteDomain = useWebsiteSettings(getWebsiteDomain)
  const websiteLocale = useWebsiteSettings(getWebsiteLocale)
  const currentWebsiteLocale = useWebsiteSettings(getCurrentWebsiteLocale)
  const websiteId = useWebsiteSettings(getWebsiteId) as number
  const { data } = websitePagesQuery.useQuery({ queryFnArgs: [websiteId] })
  const pageData = data?.pages.find(websitePageSet =>
    websitePageSet.locales.find(
      websitePage => websitePage.id === websitePageId,
    ),
  )

  const websitePage = pageData?.locales.find(
    websitePage => websitePage.id === websitePageId,
  )

  const isMainLocale = websiteLocale === currentWebsiteLocale

  const [pathWithoutLocale, setPathWithoutLocale] = useState(
    removeLocalePrefixFromPath(websitePage?.path || ''),
  )

  const websiteDomainName = websiteDomain?.name ?? DOMAIN_PLACEHOLDER
  const websiteDomainNameWithLocale =
    currentWebsiteLocale && !isMainLocale
      ? `${websiteDomainName}/${currentWebsiteLocale}`
      : websiteDomainName

  const path = isMainLocale
    ? pathWithoutLocale
    : `${currentWebsiteLocale}/${pathWithoutLocale}`

  useEffect(() => {
    removeLocalePrefixFromPath(websitePage?.path || '')
  }, [websitePage?.path, websiteLocale])

  return {
    websiteDomainNameWithLocale,
    websiteDomainName,
    path,
    pathWithoutLocale,
    setPathWithoutLocale,
  }
}
